// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  rutaPrediccion: 'https://diana-fastapi.deptapps-instances.automation-coe.com',
  rutaGeneracion: 'https://diana-fastapi.deptapps-instances.automation-coe.com',
  rutaProvisional: 'https://diana-fastapi.deptapps-instances.automation-coe.com',
  // rutaProvisional: 'http://127.0.1.1:9000',
  // rutaPrediccion: 'http://127.0.1.1:9000',
  // rutaGeneracion: 'http://127.0.1.1:9000',
  backLogin: 'https://security-automl.deptapps-instances.automation-coe.com' 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
